
import { useToken } from "./token_context";
import React from 'react';

export function TokenEnterModal() {
    const {token, setAndValidateToken} = useToken();

    const [message, setMessage] = React.useState("");

    React.useEffect(() => {
        if (!token.validated) {
            document.getElementById('token_modal').showModal();
        };
    });

    function onClick_OK(evt) {
        evt.preventDefault()
        const tkn = document.getElementById("token").value;
        setAndValidateToken(tkn).then((ok) => {
            if (!ok) {
                setMessage("Token is invalid!")
            } else {
                document.getElementById('token_modal').close();
            };
        });
    };

    return (
        <dialog id="token_modal" className="modal">

          <div className="modal-box">
            <h3 className="font-bold text-lg py-2">Hello! Please enter valid token.</h3>

            <fieldset className="fieldset">
              <input type="text" name="token" id="token" className="input text-xl" placeholder="Token" />
              <p className="label text-red-500 text-lg">{ message }</p>
            </fieldset>

            <div className="modal-action">
              <form method="dialog">
                <button className="btn" onClick={onClick_OK} >OK</button>
              </form>
            </div>
          </div>
        </dialog>
      );
}
